import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  type?: 'website' | 'organization' | 'mobileApplication';
  data?: any;
}

const StructuredData = ({ type = 'website', data }: StructuredDataProps) => {
  const getStructuredData = () => {
    switch (type) {
      case 'website':
        return {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Vespid",
          "description": "Malaysia's leading gamified financial literacy education platform",
          "url": "https://vespid.my",
          "sameAs": [
            "https://www.instagram.com/vespid_my/",
            "https://www.linkedin.com/company/vespid",
            "https://www.tiktok.com/@vespid_my"
          ],
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://vespid.my/?s={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        };
      
      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Vespid",
          "description": "Gamified financial literacy education platform",
          "url": "https://vespid.my",
          "logo": "https://vespid.my/vespidLogo.png",
          "foundingDate": "2023",
          "foundingLocation": {
            "@type": "Place",
            "addressCountry": "Malaysia"
          },
          "areaServed": "Malaysia",
          "knowsAbout": [
            "Financial Literacy",
            "Personal Finance Education",
            "Investment Education",
            "Budgeting",
            "Money Management",
            "Gamified Learning"
          ],
          "sameAs": [
            "https://www.instagram.com/vespid_my/",
            "https://www.linkedin.com/company/vespid",
            "https://www.tiktok.com/@vespid_my"
          ]
        };
      
      case 'mobileApplication':
        return {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "Vespid",
          "description": "Gamified personal finance learning mobile app",
          "applicationCategory": "EducationApplication",
          "operatingSystem": ["iOS", "Android"],
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "MYR"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.5",
            "ratingCount": "2000"
          },
          "downloadUrl": [
            "https://play.google.com/store/apps/details?id=com.vespid",
            "https://apps.apple.com/app/vespid"
          ]
        };
      
      default:
        return data || {};
    }
  };

  const structuredData = data || getStructuredData();

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;